import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { JwtHelperService } from '@auth0/angular-jwt';

import { CKPassLoginModel } from '@core/models/interfaces/login.interface';
import { LocalStorageService, keyTriggerSession } from '../common';
import { AuthService } from './auth.service';
import { LOCAL_STORAGE_KEY } from '@core/configs/local-storage-key.config';
import { ROUTER_CONFIG } from '@core/configs/router.config';

@Injectable()
export class LoginService {
    jwtHelper = new JwtHelperService();

    constructor(
        public translate: TranslateService,
        private router: Router,
        private authService: AuthService,
        private localStorageService: LocalStorageService,
    ) { }

    async loginByCKPass(loginData: CKPassLoginModel) {
        try {
            const res = await this.authService.loginByCKPass(loginData);
            if (res && res.result) {
                const userSession = {
                    accessToken: res.result.accesstoken,
                    refreshToken: res.result.refreshtoken,
                };
                this.localStorageService.setUserSession(userSession);
                this.localStorageService.trigger(keyTriggerSession.setToken);

                this.localStorageService.setItem(LOCAL_STORAGE_KEY.userId, res.result.userid);
                // localStorage.setItem(LOCAL_STORAGE_KEY.userId, res.result.userid);

                const fullName = res.result.lastname + res.result.firstname;
                localStorage.setItem(LOCAL_STORAGE_KEY.fullName, fullName);
                localStorage.setItem(LOCAL_STORAGE_KEY.handleFirstMenu, JSON.stringify(false));
                this.authService.setIsLoggedIn(true);
                return true;
            }
        } catch (e) {
            throw e;
        }
    }
}
